/*
 *
 * WebhookNotifications reducer
 *
 */
import produce from 'immer';
import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  // HANDLE_UPDATE_WEBHOOK_NOTIFICATIONS_STATUS,
  UPDATE_WEBHOOK_NOTIFICATIONS_DATA,
  RESET_DATA,
  HANDLE_UPDATE_NOTIFICATION_CHANNEL_DETAILS,
  HANDLE_ADD_NOTIFICATION_CHANNEL_DETAILS_RESPONSE,
  PAYMENTS,
  PAYMENT_LINK,
  SETTLEMENTS,
  REFUNDS,
  VENDOR_SETTLEMENTS,
  INSTRUMENT,
  PAYMENT_FORM,
  TRANSACTION,
  UPDATE_ABANDONED_CHECKOUT_SECRET_KEY,
} from './constants';

export const getInitialState = () => ({
  isLoading: false,
  webhooks: {
    [PAYMENT_LINK]: [],
    [PAYMENT_FORM]: [],
    [TRANSACTION]: [],
  },
  version: {},
  currentPageRowData: [],
  abandonedCheckoutSecretKey: '',
});

export const initialState = {
  ...getInitialState(),
};

/* eslint-disable default-case, no-param-reassign */
const webhookNotificationsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case UPDATE_WEBHOOK_NOTIFICATIONS_DATA: {
        const { key, type, data } = action.data;
        if ([SETTLEMENTS, VENDOR_SETTLEMENTS, PAYMENTS].includes(key))
          draft.webhooks[key][type] = data;
        else draft.webhooks[key] = data;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      // case HANDLE_UPDATE_WEBHOOK_NOTIFICATIONS_STATUS: {
      //   const { notificationType } = action.data;
      //   const index = draft.webhooks[PAYMENTS].findIndex(
      //     obj => obj.notificationType === notificationType,
      //   );
      //   if (index >= 0) draft.webhooks[PAYMENTS][index] = action.data;
      //   break;
      // }
      case HANDLE_UPDATE_NOTIFICATION_CHANNEL_DETAILS: {
        const { data, key } = action.data;
        if ([REFUNDS, INSTRUMENT, PAYMENT_FORM].includes(key)) {
          const index = draft.webhooks[key].findIndex(
            obj => obj.channelValue === data.channelValue,
          );
          if (index >= 0) draft.webhooks[key][index] = data;
        } else {
          const { notificationType, channelValue } = data;
          const index = draft.webhooks[key][notificationType].findIndex(
            obj => obj.channelValue === channelValue,
          );
          if (index >= 0) draft.webhooks[key][notificationType][index] = data;
        }
        break;
      }
      case HANDLE_ADD_NOTIFICATION_CHANNEL_DETAILS_RESPONSE: {
        const { data, key } = action.data;
        if ([REFUNDS, INSTRUMENT, PAYMENT_FORM].includes(key)) {
          draft.webhooks[key].unshift(data);
        } else {
          const { notificationType } = data;
          draft.webhooks[key][notificationType].unshift(data);
        }
        break;
      }
      case RESET_DATA: {
        const obj = getInitialState();
        Object.keys(obj).forEach(k => (draft[k] = obj[k])); // eslint-disable-line
        break;
      }
      case UPDATE_ABANDONED_CHECKOUT_SECRET_KEY: {
        draft.abandonedCheckoutSecretKey = action.data;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default webhookNotificationsReducer;
